<template>
    <div class="n2-center-container" style="background-color: #fff; padding: 10px;">
        <div>
            <a @click="$router.go(-1)" class="n2-link-back">
                <div style="display: flex; align-items:center;">
                    <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                    <span style="margin-left:5px;">
                        {{$t('pages.account.profile.back')}}
                    </span>
                </div>
            </a>
        </div>
        <div v-if="!success" style="padding:0;">
            <h4 class="n2-text-center">{{$t('pages.account.profile.profile')}}</h4>
            <div style="max-width:600px;">
                <form-input type="text" v-model="contact.given_name" v-bind:label="$t('pages.account.profile.given_name')" v-bind:errors="model_errors.given_name"></form-input>
                <form-input type="text" v-model="contact.family_name" v-bind:label="$t('pages.account.profile.family_name')" v-bind:errors="model_errors.family_name"></form-input>
                <form-input type="text" v-model="contact.address.address_line_1" v-bind:label="$t('pages.account.profile.address_line_1')" v-bind:errors="model_errors.address_line_1"></form-input>
                <form-input type="text" v-model="contact.address.postal_code" v-bind:label="$t('pages.account.profile.postal_code')" v-bind:errors="model_errors.postal_code"></form-input>
                <form-input type="text" v-model="contact.address.locality" v-bind:label="$t('pages.account.profile.locality')" v-bind:errors="model_errors.locality"></form-input>
                <div class="n2-form-group">
                    <label class="n2-form-label">
                        {{$t('pages.account.profile.country_code')}}
                    </label>

                    <app-autocomplete v-model="contact.address.country_code"
                                      v-bind:items="countries"
                                      v-bind:text_field="'name'"
                                      v-bind:separator="' '"
                                      v-bind:value_field="'code'"
                                      v-bind:errors="model_errors.country_code">
                    </app-autocomplete>


                </div>
                <form-input type="text" v-model="contact.phone_number" v-bind:label="$t('pages.account.profile.phone_number')" v-bind:errors="model_errors.phone_number"></form-input>
                <form-input type="text" v-model="contact.email" v-bind:label="$t('pages.account.profile.email')" v-bind:errors="model_errors.email"></form-input>
                <form-input type="text" v-model="contact.email_repeat" v-bind:label="$t('pages.account.profile.email_repeat')" v-bind:errors="model_errors.email_repeat"></form-input>
                <validation-summary v-bind:errors="model_errors"></validation-summary>
                <!-- <div class="n2-margin-top">
                    <button class="n2-button-1" v-on:click="update">{{$t('pages.account.profile.update')}}</button>
                </div> -->
            </div>
        </div>
        <div v-else class="n2-text-center" style="padding:0">
            <h4>{{$t('pages.account.profile.update_success')}}</h4>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { AccountService } from '../services'

    import FormInput from "../components/shared/form-input.vue"
    import ValidationSummary from '../components/shared/validation-summary.vue';
    import AppAutocomplete from '../components/shared/autocomplete.vue'

    import country_list from '../data/country-list'

    export default {
        components: { FormInput, ValidationSummary, AppAutocomplete },
        data: function () {
            return {
                model_errors: {},
                success: false,
                contact: {
                    address: {
                        country_code: 'NO'
                    }
                }
            };
        },
        computed: {
            ...mapGetters('globalization', [
                'app_locale',
                'locale',
            ]),
            ...mapGetters('identity', [
                'user'
            ]),
            countries: function () {
                if (this.app_locale == 'no') {
                    return country_list.no
                }
                else {
                    return country_list.en
                }
            }
        },
        created: function () {
            this.accountService = new AccountService()
        },
        mounted: async function () {
            console.log(this.contact)
            this.contact = await this.accountService.getDetails();
            this.contact.email_repeat = this.contact.email;
        },
        methods: {
            validateForm: function () {
                this.model_errors = {}
                if (!this.contact.given_name) {
                    this.model_errors['given_name'] = [this.$t('pages.account.profile.error_given_name')]
                }
                if (!this.contact.family_name) {
                    this.model_errors['family_name'] = [this.$t('pages.account.profile.error_family_name')]
                }
                if (!this.contact.address.address_line_1) {
                    this.model_errors['address_line_1'] = [this.$t('pages.account.profile.error_address_line_1')]
                }
                if (!this.contact.address.postal_code) {
                    this.model_errors['postal_code'] = [this.$t('pages.account.profile.error_postal_code')]
                }
                if (!this.contact.address.locality) {
                    this.model_errors['locality'] = [this.$t('pages.account.profile.error_locality')]
                }
                if (!this.contact.address.country_code) {
                    this.model_errors['country_code'] = [this.$t('pages.account.profile.error_country_code')]
                }
                if (!this.contact.phone_number) {
                    this.model_errors['phone_number'] = [this.$t('pages.account.profile.error_phone_number')]
                }
                let patternEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                if (!patternEmail.test(this.contact.email)) {
                    this.model_errors['email'] = [this.$t('pages.account.profile.error_email')]
                }
                if (this.contact.email != this.contact.email_repeat) {
                    this.model_errors['email_repeat'] = [this.$t('pages.account.profile.error_email_repeat')]
                }
                //////////////////
                if (Object.keys(this.model_errors).length > 0) {
                    return false
                }
                else {
                    return true
                }
            },
            update: async function () {
                if (!this.validateForm()) {
                    return
                }
                // try {
                //     await this.customerService.update(this.contact)
                //     this.success = true
                //     this.$store.commit('identity/set_user', this.contact)

                // }
                // catch (err) {
                //     console.log(err.response)
                //     if (err.response && err.response.data && err.response.data.errors) {
                //         if (err.response.data.errors.email) {
                //             this.$set(this.model_errors, 'email', [this.$t('pages.account.profile.error_email_exist')])
                //         }
                //     }
                // }
            }
        }
    }
</script>
